import { InjectionToken } from '@angular/core';
import { FileUploaderInterface } from '@vendasta/forms';
import { Observable } from 'rxjs';
import { AttachmentInterface, ProjectTrackerUserDetails } from './shared/interfaces';

export const ProjectTrackerServiceInterfaceToken: InjectionToken<ProjectTrackerServiceInterface> =
  new InjectionToken<ProjectTrackerServiceInterface>('ProjectTrackerServiceInterface');

export interface ProjectTrackerServiceInterface {
  activeUser$: Observable<ProjectTrackerUserDetails>;
  partnerId$: Observable<string>;
  sendFeedback(partnerId: string, accountGroupId: string, taskId: string, feedback: string): Observable<any>;
  uploadFile(partnerId: string, accountGroupId: string, taskId: string, file: AttachmentInterface): Observable<any>;
  removeFile(partnerId: string, accountGroupId: string, taskId: string, file: AttachmentInterface): Observable<any>;
  approveTask(partnerId: string, accountGroupId: string, taskId: string): Observable<any>;
  undoApproveTask(partnerId: string, accountGroupId: string, taskId: string): Observable<any>;
}

export const ProjectTrackerFileUploadServiceInterfaceToken: InjectionToken<FileUploaderInterface> =
  new InjectionToken<FileUploaderInterface>('ProjectTrackerFileUploadServiceInterface');
